module.exports = __webpack_public_path__ + "img/exhibitions.170952a8.png";